import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const H2Headline = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 5.5C4 5.22386 3.77614 5 3.5 5C3.22386 5 3 5.22386 3 5.5V18.5C3 18.7761 3.22386 19 3.5 19C3.77614 19 4 18.7761 4 18.5V12.5H12V18.5C12 18.7761 12.2239 19 12.5 19C12.7761 19 13 18.7761 13 18.5V5.5C13 5.22386 12.7761 5 12.5 5C12.2239 5 12 5.22386 12 5.5V11.5H4V5.5ZM16.2706 18.4473C16.2706 18.7526 16.518 19 16.8232 19H21.3075C21.5664 19 21.7763 18.7901 21.7763 18.5312C21.7763 18.2723 21.5664 18.0625 21.3075 18.0625H17.7684C17.7414 18.0625 17.7195 18.0406 17.7195 18.0136C17.7195 18.0012 17.7242 17.9893 17.7326 17.9802L19.6797 15.8977C20.1797 15.3608 20.5703 14.9062 20.8516 14.5341C21.1357 14.1591 21.3345 13.8196 21.4482 13.5156C21.5646 13.2088 21.6229 12.8949 21.6229 12.5738C21.6229 12.125 21.5107 11.7173 21.2862 11.3508C21.0618 10.9843 20.7521 10.6932 20.3572 10.4772C19.9624 10.2613 19.5092 10.1534 18.9979 10.1534C18.4893 10.1534 18.0305 10.2613 17.6215 10.4772C17.2152 10.6932 16.8942 10.9943 16.6584 11.3807C16.5029 11.6355 16.3986 11.9175 16.3457 12.2267C16.2988 12.5004 16.5298 12.7272 16.8075 12.7272C17.0852 12.7272 17.3007 12.4984 17.368 12.229C17.4012 12.0961 17.4488 11.9725 17.5107 11.8579C17.647 11.6108 17.8388 11.419 18.0859 11.2826C18.3359 11.1434 18.6286 11.0738 18.9638 11.0738C19.2791 11.0738 19.5632 11.1349 19.8161 11.2571C20.0689 11.3792 20.2678 11.5525 20.4126 11.777C20.5604 12.0014 20.6342 12.267 20.6342 12.5738C20.6342 12.8409 20.5803 13.0966 20.4723 13.3409C20.3672 13.5824 20.2053 13.8409 19.9865 14.1164C19.7678 14.3892 19.4893 14.7102 19.1513 15.0795L16.4152 18.0746C16.3222 18.1765 16.2706 18.3094 16.2706 18.4473Z"
        />
      </svg>
    )
  },
)

export default H2Headline
